import { AboutPage, Agreements, Faq } from "pages"
import { appRoute, appRouter } from "pages/app/app.routes"
import { HomePage } from "pages/home/HomePage"
import {
  instructorRoute,
  instructorRouter,
} from "pages/instructor/instructor.routes"
import InstructorPage from "pages/InstructorPage"
import { Review } from "pages/Review"
import { userRoute, userRouter } from "pages/user/user.routes"
import { createBrowserRouter } from "react-router-dom"
import { ProtectedRoute } from "ui/base/protectedRoute/ProtectedRoute"
import { MainLayout } from "ui/layout/MainLayout"
import { UserLayout } from "ui/layout/UserLayout"

export const routesPath = {
  main: "/",
  about: "/about",
  faq: "/faq",
  terms: "/policies/terms",
  privacy: "/policies/privacy-policy",
  additionalInstructorsTerms: "/policies/additional-instructors-terms",
  userRelease: "/policies/user-release",
  paymentTerms: "/policies/payment-terms",
  instructorRequirements: "/policies/instructor-requirements",
  instructorCancellation: "/policies/instructor-cancellation",
  userCancellation: "/policies/user-cancellation",
  userRefund: "/policies/user-refund",
  instructorPrivacyStandard: "/policies/instructor-privacy-standard",
  reviews: "/policies/reviews",
  ratings: "/policies/ratings",
  content: "/policies/content",
  cookies: "/policies/cookie-policy",
  copyright: "/policies/copyright",
  serviceFees: "/policies/service-fees",
  smsTerms: "/policies/sms-terms",
  taxes: "/policies/taxes",
  stripeTerms: "/policies/stripe-recipient-agreement",
  communityStandards: "/policies/community-standards",
  instructorStandards: "/policies/instructor-standards",
  instructorPage: "/instructor-page",
  instructorReview: "/instructor_review",
}

export const routes = createBrowserRouter([
  {
    path: routesPath.main,
    element: <HomePage />,
  },
  {
    path: routesPath.about,
    element: <AboutPage />,
  },
  {
    path: routesPath.faq,
    element: <Faq />,
  },
  {
    path: routesPath.privacy,
    element: <Agreements />,
  },
  {
    path: routesPath.terms,
    element: <Agreements />,
  },
  {
    path: routesPath.additionalInstructorsTerms,
    element: <Agreements />,
  },
  {
    path: routesPath.userRelease,
    element: <Agreements />,
  },
  {
    path: routesPath.paymentTerms,
    element: <Agreements />,
  },
  {
    path: routesPath.instructorRequirements,
    element: <Agreements />,
  },
  {
    path: routesPath.instructorCancellation,
    element: <Agreements />,
  },
  {
    path: routesPath.userCancellation,
    element: <Agreements />,
  },
  {
    path: routesPath.userRefund,
    element: <Agreements />,
  },
  {
    path: routesPath.instructorPrivacyStandard,
    element: <Agreements />,
  },
  {
    path: routesPath.reviews,
    element: <Agreements />,
  },
  {
    path: routesPath.ratings,
    element: <Agreements />,
  },
  {
    path: routesPath.content,
    element: <Agreements />,
  },
  {
    path: routesPath.cookies,
    element: <Agreements />,
  },
  {
    path: routesPath.copyright,
    element: <Agreements />,
  },
  {
    path: routesPath.serviceFees,
    element: <Agreements />,
  },
  {
    path: routesPath.smsTerms,
    element: <Agreements />,
  },
  {
    path: routesPath.taxes,
    element: <Agreements />,
  },
  {
    path: routesPath.communityStandards,
    element: <Agreements />,
  },
  {
    path: routesPath.instructorStandards,
    element: <Agreements />,
  },

  { path: routesPath.stripeTerms, element: <Agreements /> },

  { path: routesPath.instructorReview, element: <Review /> },

  {
    path: routesPath.instructorPage,
    element: <InstructorPage />,
  },
  {
    path: appRoute.index,
    element: <MainLayout />,
    children: appRouter,
  },

  {
    path: userRoute.index,
    element: <ProtectedRoute children={<UserLayout />} />,
    children: userRouter,
  },

  {
    path: instructorRoute.index,
    element: <ProtectedRoute children={<MainLayout />} />,
    children: instructorRouter,
  },
])
